import { render, staticRenderFns } from "./AddArea.vue?vue&type=template&id=2f351faa"
import script from "./AddArea.vue?vue&type=script&lang=js"
export * from "./AddArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports